// extracted by mini-css-extract-plugin
export default {"user":"ForwarderDataForm_user__NBwJZ","header":"ForwarderDataForm_header__CuCWZ","row":"ForwarderDataForm_row__5VtoF"};